// Where an enrollment originated. See ClickUp 868jxkz4p §3.
export const ENROLLMENT_SOURCES = [
  { id: "application", label: "Candidatura" },
  { id: "invitation", label: "Convite" },
  { id: "import", label: "Importação" },
];

export const ENROLLMENT_SOURCE_LABEL = ENROLLMENT_SOURCES.reduce(
  (acc, source) => ({ ...acc, [source.id]: source.label }),
  {}
);
